export enum CommonRoutes {
  root = "/",
  logout = "/logout",
  login = "/login",
}

export enum AccommodationRoutes {
  root = "/accommodation",
  guide = "/accommodation/guide",
}

export enum AdminRoutes {
  root = "/admin",
  employee = "/admin/employee",
  accommodation = "/admin/accommodation",
  vehicle = "/admin/vehicle",
  qna = "/admin/qna",
  addemployee = "/admin/employee/addemployee",
}

export enum MypageRoutes {
  root = "/mypage",
}

export enum TestRoutes {
  root = "/test",
}

export enum VehicleRoutes {
  root = "/vehicle",
  guide = "/vehicle/guide",
  calendar = "/vehicle/available",
  vehicleHistory = "/vehicle/history",
}

// 회의실 예약
export enum MeetingRoomRoutes {
  root = "/meetingRoom",
  guide = "/meetingRoom/guide",
}
